import { UPDATE_STORE_TYPES } from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    storeTypes: null,
};

const updateStoreTypes = (state, action) => {
    return updateState(state, {
        storeTypes: action.storeTypes,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_STORE_TYPES:
            return updateStoreTypes(state, action);
        default:
            return state;
    }
};

export default reducer;
